export default "__VITE_ASSET__CFncQgM$__"